export type TagsTranslation = {
  aliases: {
    add: string;
    delete: string;
    duplicateError: string;
    empty: string;
    error: string;
    field: string;
    info: string;
    notFoundError: string;
    title: string;
    tooLong: string;
    validation: string;
  };
  body: {
    actions: string;
    category: string;
    group: string;
    id: string;
    name: string;
  };
  deleteConfirmation: string;
  dialog: {
    buttons: {
      cancel: string;
      create: string;
      save: string;
    };
    createTitle: string;
    editTitle: string;
    fields: {
      category: string;
      name: string;
    };
    validation: {
      categoryRequired: string;
      nameRequired: string;
      nameTooLong: string;
    };
  };
  groupBadge: string;
  groupDialog: {
    buttons: {
      cancel: string;
      save: string;
    };
    field: string;
    info: string;
    title: string;
  };
  head: {
    category: string;
    searchPhrase: string;
  };
  labels: {
    aliases: string;
    delete: string;
    edit: string;
    group: string;
    merge: string;
  };
  mergeDialog: {
    buttons: {
      cancel: string;
      merge: string;
    };
    fields: {
      sourceTags: string;
      targetTag: string;
    };
    info: string;
    loadingText: string;
    noOptionsText: string;
    title: string;
    validation: {
      sourceTagsRequired: string;
      targetTagRequired: string;
    };
  };
  tooltip: {
    addTag: string;
  };
};

export const tagsTranslation: TagsTranslation = {
  aliases: {
    add: 'Add alias',
    delete: 'Delete alias',
    duplicateError: 'This alias already exists.',
    empty: 'No aliases assigned.',
    error: 'Could not update aliases.',
    field: 'Alias',
    info: 'Aliases help users find {{value}}. They do not create a separate keyword.',
    notFoundError: 'The keyword or alias no longer exists.',
    title: 'Aliases for {{value}}',
    tooLong: 'Alias cannot exceed 60 characters.',
    validation: 'Enter an alias.',
  },
  body: {
    actions: 'Actions',
    category: 'Type',
    group: 'Group',
    id: 'ID',
    name: 'Name',
  },
  deleteConfirmation:
    'Are you sure you want to delete the keyword "{{value}}"? Candidate assignments and aliases will be removed with it.',
  dialog: {
    buttons: {
      cancel: 'Cancel',
      create: 'Create',
      save: 'Save',
    },
    createTitle: 'Add Keyword',
    editTitle: 'Edit Keyword',
    fields: {
      category: 'Type',
      name: 'Name',
    },
    validation: {
      categoryRequired: 'Keyword type is required.',
      nameRequired: 'Keyword name is required.',
      nameTooLong: 'Keyword name cannot exceed 60 characters.',
    },
  },
  groupBadge: 'group · {{count}}',
  groupDialog: {
    buttons: {
      cancel: 'Cancel',
      save: 'Save',
    },
    field: 'Group (parent keyword)',
    info: 'A search by the group keyword also matches all keywords in the group, while a search by a single keyword in the group matches only that keyword. Groups have one level: the parent must be a top-level keyword of the same type, and a keyword that already has its own group members cannot join another group. Leave the field empty to remove the keyword from its group.',
    title: 'Group of "{{value}}"',
  },
  head: {
    category: 'Type',
    searchPhrase: 'Search by name',
  },
  labels: {
    aliases: 'Aliases',
    delete: 'Delete',
    edit: 'Edit',
    group: 'Group',
    merge: 'Merge',
  },
  mergeDialog: {
    buttons: {
      cancel: 'Cancel',
      merge: 'Merge',
    },
    fields: {
      sourceTags: 'Keywords to merge',
      targetTag: 'Target keyword',
    },
    info: 'Merging replaces the selected source keywords with the target keyword. Candidate assignments and aliases are rewritten to the target keyword, and the source keywords are deleted.',
    loadingText: 'Loading keywords...',
    noOptionsText: 'No keywords found',
    title: 'Merge Keywords',
    validation: {
      sourceTagsRequired: 'Select at least one keyword to merge.',
      targetTagRequired: 'Target keyword is required.',
    },
  },
  tooltip: {
    addTag: 'Add keyword',
  },
};
